import React, { useState, useEffect } from 'react';
import colorData from '../data/colors.json';

function ColorGrid({ onImageSelect }) {
  const [colors, setColors] = useState([]);
  
  useEffect(() => {
    // 处理图片路径
    const processedColors = colorData.map(color => ({
      ...color,
      thumbnailUrl: color.thumbnailUrl.replace('%PUBLIC_URL%', process.env.PUBLIC_URL),
      fullUrl: color.fullUrl.replace('%PUBLIC_URL%', process.env.PUBLIC_URL)
    }));
    setColors(processedColors);
  }, []);

  return (
    <div className="color-grid">
      {colors.map(color => (
        <div 
          key={color.id} 
          className="color-item"
          onClick={() => onImageSelect(color)}
        >
          <div 
            className="color-thumbnail" 
            style={{ backgroundImage: `url(${color.thumbnailUrl})` }}
            role="img"
            aria-label={`${color.name} - Click to preview and download this background`}
          />
          <div className="color-name">{color.name}</div>
        </div>
      ))}
    </div>
  );
}

export default ColorGrid; 